import React, { useContext } from 'react';
import GlobalContext from 'hooks/contexts/GlobalContext';
import { ImageObj } from 'types';

interface SchoolLogoProps {
  logo: {
    mobile: ImageObj;
    desktop: ImageObj;
  };
  alt: string;
  className: string;
}

function SchoolLogo({
  logo,
  alt,
  className,
}: SchoolLogoProps): React.ReactElement {
  const {
    windowSize: { currentBreakpoint = 'mobile' },
  } = useContext(GlobalContext);

  const isMobile = currentBreakpoint === 'mobile';

  function _getSchoolLogoUrl(
    imageMap: SchoolLogoProps['logo'] = {
      mobile: { url: '' },
      desktop: { url: '' },
    }
  ): string {
    return isMobile ? imageMap.mobile.url : imageMap.desktop.url;
  }

  return <img src={_getSchoolLogoUrl(logo)} alt={alt} className={className} />;
}

export default SchoolLogo;
